import { render, staticRenderFns } from "./ArchivedLocation.vue?vue&type=template&id=6c614d9e&scoped=true&"
import script from "./ArchivedLocation.vue?vue&type=script&lang=js&"
export * from "./ArchivedLocation.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedLocation.vue?vue&type=style&index=0&id=6c614d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c614d9e",
  null
  
)

export default component.exports